import { IconFileInvoice, IconInbox, IconReceipt } from "@tabler/icons-react";
import { ModuleLanding, NoteText } from "../../shell/ModuleLanding";

export function SalesHome() {
  return (
    <ModuleLanding
      title="Sales"
      subtitle="Confirm what can be supplied, then bill it"
      tiles={[
        {
          to: "/sales/queue",
          label: "Day Orders",
          blurb: "What Marketing has captured and is waiting on you",
          icon: <IconInbox size={21} stroke={1.6} />,
        },
        {
          to: "/sales/orders",
          label: "Orders",
          blurb: "Confirmed orders, and which are still to be billed",
          icon: <IconFileInvoice size={21} stroke={1.6} />,
        },
        {
          to: "/sales/bills",
          label: "Bills",
          blurb: "Everything billed, most recent first",
          icon: <IconReceipt size={21} stroke={1.6} />,
        },
      ]}
      noteTitle="Before you start"
      note={
        <NoteText>
          Confirming an order does not move stock. Generating the bill is the
          one step that does, and a bill cannot be generated twice for the same
          order.
        </NoteText>
      }
    />
  );
}
